import { render } from "./ProcessSteps.vue?vue&type=template&id=9fb4513e"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__